import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarEnderecosEntrega(axios, parametros) {    
    parametros.operacao = 'buscarEnderecosEntrega';
  
    let retorno = {};

    await axios.santriGET('/rest/endereco', parametros, 10, false)
    .then(response => {
     retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
     retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/REndereco/REnderecoBuscarEnderecosEntrega.js